module.exports = __webpack_public_path__ + "img/TheDeck.6d264717.jpeg";